module.exports = __webpack_public_path__ + "static/media/ranger.136e5d20.png";